<template>
  <body>
    <div
      id="main-wrapper"
      data-layout="vertical"
      data-navbarbg="skin5"
      data-sidebartype="full"
      data-sidebar-position="absolute"
      data-header-position="absolute"
      data-boxed-layout="full"
    >
      <Header></Header>

      <Sidebar></Sidebar>

      <div class="dashboard-wrapper page-wrapper">
        <div class="page-breadcrumb">
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
              <h4 class="page-title">Edit inspired</h4>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 col-xlg-9 col-md-12">
              <form
                class="form-horizontal form-material"
                v-on:submit.prevent="submit"
              >
                <div class="card profile-card">
                  <div class="card-body">
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Title</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name="title"
                          v-model="item.title"
                        />
                      </div>
                    </div>
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Short Description</label>
                      <div class="col-md-12 border-bottom p-0">
                        <textarea
                          v-model="item.short_description"
                          class="form-control form-control-lg"
                          rows="2"
                        ></textarea>
                      </div>
                    </div>
                       <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Button Text</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name="title"
                          v-model="item.btext"
                        />
                      </div>
                    </div>
                                   <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Inspired Image</label>
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input
                            type="file"
                            @change="previewImage"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValue.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValue"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageData!=null">
                          <img class="preview" :src="picture" />

                          <a @click="onUpload" class="upload-btn">Upload</a>
                        </div>
                        <div v-else>
                          <img class="imagefromdata" :src="item.image" />
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>

                <div class="card profile-card">
                  <div class="card-body">
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Meta Title</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name=""
                          v-model="item.meta_title"
                        />
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Meta Description</label>
                      <div class="col-md-12 border-bottom p-0">
                        <textarea
                          name="meta_description"
                          v-model="item.meta_description"
                          class="form-control form-control-lg"
                          rows="5"
                        ></textarea>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Meta Keywords</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name="meta_keywords"
                          v-model="item.meta_keywords"
                        />
                      </div>
                    </div>

                    <br />
                    <div class="form-group mb-4">
                      <div class="col-sm-12">
                        <input
                          type="submit"
                          class="btn btn-primary"
                          value="Submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>
  </body>
</template>

<script>

import Header from './../admin-header';
import Footer from './../admin-footer';
import Sidebar from './../admin-sidebar';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import firebase from 'firebase';
/*import $ from 'jquery'*/

import { db } from '../../main'

export default{
     name: 'Edit',
        data(){
            return{
                item:{},
                imageData: null,
 picture: null,
			uploadValue: 0,           
               
                editor: ClassicEditor,
                editorData: '<p>Content of the editor.</p>',
                editorConfig: {
                    // The configuration of the editor.

                },
            }
        },
        components:{
            'Header':Header,
            'Sidebar':Sidebar,
            'Footer':Footer,

        },

        created: function(){
            this.getItem();
            this.getCategories();
            this.getIcons();
        },

        methods: {
               getItem()
            {
                var id = this.$route.params.id;

                db.collection('inspired').doc(id).get().then((doc) => {
                    this.item = doc.data();
                     this.picture = doc.data().image;
	
                })
            },
          previewImage(event) {
				this.uploadValue = 0;
				this.picture = null;
				this.imageData = event.target.files[0];
				console.log(this.imageData);
			},
			onUpload() {
				this.picture = null;
      // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageData.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
          }
          return result;
        }
				const storageRef = firebase.storage().ref(imagename+makeid(5)+imageextension).put(this.imageData);
				storageRef.on('state_changed', snapshot => {
					this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValue = 100;
					storageRef.snapshot.ref.getDownloadURL().then((url) => {
						this.picture = url;
            //alert(this.picture);
					});
				});
			},
          
            submit()
            {	
    
                var id = this.$route.params.id;
                var  date = new Date().toLocaleString();//.toISOString().slice(0, 10);
                db.collection("inspired")
                .doc(id)
                .update({
                 btext:this.item.btext,
                  title: this.item.title,
                  short_description: this.item.short_description,
                  meta_title: this.item.meta_title,
                  meta_description: this.item.meta_description,
                  meta_keywords: this.item.meta_keywords,
                  image:this.picture,
                  modified: date,
                })
                .then(() => {
                  console.log("Document successfully updated!");
                  //this.readEmployees();
                  this.$toasted.success('Success, Updated Successfully!', {
                    icon : 'check',
                     //icon : 'error_outline'
                 })
                 this.$router.push('/inspired/index');

                })
                .catch((error) => {
                  // The document probably doesn't exist.
                  console.error("Error updating document: ", error);
                });
            }
        }
    }
</script>
